<template>
  <div>
      <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <ValidationProvider v-slot="{ errors, validate, valid }" :rules="validation">
          <v-text-field
              :label="title"
              readonly
              :value="x"
              v-on="on"
              filled
              clearable
              :error-messages="errors"

          ></v-text-field>
            </ValidationProvider>
        </template>
        <v-date-picker
            :locale="iso"
            v-model="x"
            no-title
            @input="dateMenu = false,sendto()"
        ></v-date-picker>
      </v-menu>

  </div>
</template>


<script>
    import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';

    setInteractionMode('eager')

    export default {
        name: 'CalendarSelect',
        data() {
            return {
                dateMenu: false,
                dateVal: "",
                x:"2020-01-01"
            }
        },
        inject: ['parentValidator'],
        props: {
            mydate: String,
            title: String,
            iso: String,
            validation:Object
        },
        components: {
            ValidationProvider, ValidationObserver
        },
        methods:{
            sendto(){
                console.log("changing",this.x)
                this.$emit("calendar-change",this.x)
            }
        },
        watch: {
            mydate: function (n,o) {
                this.x = n.substring(0,10)
            }
        },
        mounted() {
            this.x = this.mydate
        },
        created() {
            this.$validator = this.parentValidator
        },
    }
</script>